module.exports = __webpack_public_path__ + "static/media/4-min.e3c5a41c.jpg";